
<div >
    <v-row class="no-frame"
    >
        <v-col class="no-frame col-4"  style="height: 680px;">
            <div class="primary--text site-title">
                Komponenten mit Gewährleistung
            </div>
            <div class="lm-border pt-2 pb-3 pl-1 pr-1 mr-3 mb-3" style="height: calc(100% - 23px)">
                <div
                    v-for  = "(component, index) in site.components "
                    :key   = "index"
                    class  = "no-frame w-100 pl-2 pr-2 pt-1 component"
                    :class = "selected && (selected.id === component.id) ? 'primary white--text' : !component.id ? 'background-aliceblue' : ''"
                    @click = "onSelect (component)"
                >
                    <v-col class="no-frame v-flex">
                        <div class="pt-0 component-name" style="width: calc(100% - 85px);" :style="!component.id ? ' font-weight: bold' : ''">
                            {{ component.name }}
                        </div>
                        <v-icon :color="selected && (selected.id === component.id) ? 'white' : ''"
                        >
                            {{ icon(component) }}
                        </v-icon>
                        <div class="text-right" style="width: 85px" :style="!component.id ? ' font-weight: bold' : ''">
                            {{ date(component.warrantyDate) }}
                        </div>
                    </v-col>

                </div>
            </div>

        </v-col>
        <v-col class="no-frame" style="max-height: 600px; overflow-y: scroll">
            <inc-warranty-incident
                v-for="(incident, index) in site.incidents"
                :incident="incident"
                :selected="selected"
                :key="index"
                :class="index < site.incidents.length - 1 ? 'mb-5' : ''"
                @close="onClose"
            />
            <div>
            </div>
        </v-col>
    </v-row>
</div>

